import { Link } from "react-router-dom";
import PageTransition from "../components/PageTransition";


const Home: React.FC = () => {
    return (
        <PageTransition>
        <div className="bg-gradient-to-b from-transparent via-transparent to-transparent dark:bg-gray-900">
            {/* Hero Section */}
            <div className="relative overflow-hidden bg-gradient-to-b from-brand-50 to-yellow-50 dark:from-gray-800 dark:to-gray-900 min-h-[calc(100vh-6rem)] flex items-center">
                {/* Background Image Layer */}
                <div
                    className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                    style={{ backgroundImage: 'url(/images/hero.svg)' }}
                    aria-hidden="true"
                />

                {/* Content Layer */}
                <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
                    <div className="text-center animate-slide-up">
                        <h1 className="text-5xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-7xl">
                            The Brilliance of Blossoms
                        </h1>

                        <div className="mt-8 max-w-2xl mx-auto space-y-5 text-lg leading-8 text-gray-600 dark:text-gray-400">
                            <p>
                                Those petals. Delicate. Glorious. Brilliant. Through millions of years, flowers have
                                evolved astonishing strategies to thrive in every landscape—from sun-scorched deserts
                                to frozen alpine peaks.
                            </p>
                            <p>
                                Anchored to her landscape, a blossom can't walk to water, migrate with the weather,
                                or swat away a nibbling pest. Yet she persists—adapting with ingenuity, timing,
                                chemistry, and sheer determination.
                            </p>
                            <p>
                                In our own human way, we do the same.
                            </p>
                            <p>
                                Through a fusion of botany, art, and storytelling, <em>The Brilliance of Blossoms</em>{" "}
                                pairs eight real flowers with eight human adaptability personalities—revealing how
                                nature's strategies mirror our own.
                            </p>
                            <p className="text-2xl font-bold text-gray-900 dark:text-white">
                                Eight blossoms. Eight strategies. Which One Are You?
                            </p>
                        </div>

                        <div className="mt-10 flex items-center justify-center gap-x-6">
                            <Link
                                to="/quiz"
                                className="rounded-md bg-brand-500 px-4 py-2 text-base sm:px-8 sm:py-4 sm:text-lg font-semibold text-white shadow-lg hover:bg-brand-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 transition-all transform hover:scale-105"
                            >
                                Take the Quiz Now
                            </Link>
                            <Link
                                to="/about"
                                className="text-base sm:text-lg font-semibold leading-7 text-gray-900 dark:text-white hover:text-brand-600 dark:hover:text-brand-400"
                            >
                                Learn more <span aria-hidden="true">→</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        </PageTransition>
    );
};

export default Home;
